import { useQuery } from 'react-query'
import { getCustomerById } from '../../customers'

export default function useCustomer(id: string) {
  const { data, error, isLoading } = useQuery(['customer', id], () =>
    getCustomerById(id)
  )
  return { data, error, isLoading }
}
